import { tierById } from "@/data/catalogue";
import { cn } from "@/lib/utils";

export function TierBadge({ tierId, className }) {
  const tier = tierById(tierId);
  if (!tier) return null;
  return (
    <span
      data-testid={`tier-badge-${tierId}`}
      className={cn(
        "inline-flex items-center gap-1.5 border px-2.5 py-1 font-mono text-[11px] font-semibold uppercase tracking-wider",
        tier.badgeClass,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", tier.dotClass)} />
      {tier.label}
    </span>
  );
}
